/* Teletone curated search: resolution, redirect, logging.
   Reads window.TTSearchMap (from snippet tt-search-map).
   Reads window.TTSearchLogEndpoint (optional, from theme settings). */
(function () {
  var MAP = window.TTSearchMap || { exact: {}, categories: {}, concepts: {} };

  function normalize(raw) {
    return (raw || '')
      .toLowerCase()
      .trim()
      .replace(/[’']/g, '')
      .replace(/\s+/g, ' ');
  }

  // Decide what a query resolves to, without navigating.
  // Returns { type, handles?, url? } where type is exact | category | concept | none.
  function resolve(raw) {
    var q = normalize(raw);
    if (!q) return { type: 'none', handles: [] };

    if (MAP.exact[q]) return { type: 'exact', url: MAP.exact[q] };
    if (MAP.messages && MAP.messages[q]) {
      var m = MAP.messages[q];
      return { type: 'message', text: m.text, cta: m.cta, url: m.url };
    }
    if (MAP.categories[q]) return { type: 'category', handles: MAP.categories[q] };
    if (MAP.concepts[q]) return { type: 'concept', handles: MAP.concepts[q] };

    // Loose pass: if any known concept/category word appears inside a longer query
    // (e.g. "dark cinematic pads"), collect every match and union the results.
    var union = [];
    var matched = 'none';
    Object.keys(MAP.concepts).forEach(function (key) {
      if (key.indexOf(' ') === -1 ? wordIn(q, key) : q.indexOf(key) !== -1) {
        matched = 'concept';
        MAP.concepts[key].forEach(function (h) { if (union.indexOf(h) === -1) union.push(h); });
      }
    });
    Object.keys(MAP.categories).forEach(function (key) {
      if (wordIn(q, key)) {
        if (matched === 'none') matched = 'category';
        MAP.categories[key].forEach(function (h) { if (union.indexOf(h) === -1) union.push(h); });
      }
    });
    if (union.length) return { type: matched, handles: union };

    return { type: 'none', handles: [] };
  }

  function wordIn(q, word) {
    return (' ' + q + ' ').indexOf(' ' + word + ' ') !== -1;
  }

  function log(raw, outcome, count, source) {
    var endpoint = window.TTSearchLogEndpoint;
    if (!endpoint) return;
    var payload = {
      q: raw,
      normalized: normalize(raw),
      match: outcome,
      results: typeof count === 'number' ? count : null,
      source: source || 'unknown',
      path: window.location.pathname,
      ts: new Date().toISOString()
    };
    try {
      // Fire and forget. no-cors so the Apps Script endpoint needs no CORS headers.
      fetch(endpoint, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload),
        keepalive: true
      });
    } catch (e) { /* logging never blocks the customer */ }

    // Optional GA4 mirror if gtag is present.
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'search', { search_term: normalize(raw), tt_match: outcome, tt_results: count });
    }
  }

  function toResultsUrl(raw) {
    return '/search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(raw);
  }

  // Wire every form that opts in with data-tt-search-form.
  function wireForms() {
    document.querySelectorAll('[data-tt-search-form]').forEach(function (form) {
      if (form.dataset.ttBound) return;
      form.dataset.ttBound = '1';
      form.addEventListener('submit', function (e) {
        var input = form.querySelector('input[name="q"]');
        var raw = input ? input.value : '';
        if (!normalize(raw)) { e.preventDefault(); return; }
        var r = resolve(raw);
        var source = form.getAttribute('data-tt-source') || 'form';
        if (r.type === 'exact') {
          e.preventDefault();
          log(raw, 'exact', 1, source);
          window.location.assign(r.url);
        }
        // For everything else let the form navigate to /search, where the
        // results page resolves and logs with the real outcome + count.
      });
    });
  }

  window.TTSearch = { normalize: normalize, resolve: resolve, log: log, toResultsUrl: toResultsUrl };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireForms);
  } else {
    wireForms();
  }
})();
